import { createSelector, MemoizedSelector } from '@ngrx/store';
import { getPaceFormsState } from './pace-forms.selector';
import { NotificationIdentifier } from '@evorait/pace-core';
import { NotificationUtilities } from '../../utilities/notification-utilities';
import { LastOpenedFormState } from '../state/last-opened-form.state';
import { FormIdentifier, FormsState } from '@evorait/pace-forms';

export const getLastOpenedForm = createSelector(getPaceFormsState, (state) => state.lastOpenedForm);
export const getLastOpenedFormByNotificationFactory = (props: {
    notification: NotificationIdentifier;
}): MemoizedSelector<FormsState, FormIdentifier | undefined, (x: LastOpenedFormState) => FormIdentifier | undefined> =>
    createSelector(
        getLastOpenedForm,
        (lastOpenedForm: LastOpenedFormState) => lastOpenedForm[NotificationUtilities.toString(props.notification)],
    );
